import { Outlet } from "react-router-dom";

export default function CallJob() {
  return <Outlet />;
}
